const UNAUTHORIZED_ACCESS_ERROR = 'User not authorized to view the content or content not found.';

export const isUnauthorizedAccessError = (error: Error): boolean => {
	return error.message.includes(UNAUTHORIZED_ACCESS_ERROR);
};
